interface MetaTokens {
  style: string;
  color: string;
  configuration: string;
  size: string;
  price: string;
  product: string;
  facet: string;
  category: string;
}

// TODO: i18n
const formatStyle = (style: string) => style.replace(" Fit", "");
const formatCategory = (category: string) => category.replace("All ", "");
const formatFacet = (facet: string) => facet.replace("+", "with ");
const formatConfiguration = (configuration: string) =>
  `${configuration} Drawer`;
const formatProduct = (product: string) => {
  const base = product.replace("The ", "");
  return base.replace(" Sheet Set", "").replace("Dresser Drawer", "Dresser");
};

const constructTitleParts = (tokens: Partial<MetaTokens>): string[] => {
  const parts: string[] = [];

  if (tokens.style) parts.push(formatStyle(tokens.style));
  if (tokens.color) parts.push(tokens.color);
  if (tokens.configuration)
    parts.push(formatConfiguration(tokens.configuration));
  if (tokens.size) parts.push(tokens.size);
  if (tokens.price) parts.push(tokens.price);
  if (tokens.product) parts.push(formatProduct(tokens.product));
  if (tokens.facet) parts.push(formatFacet(tokens.facet));
  if (tokens.category) {
    const category = formatCategory(tokens.category);
    parts.push(parts.length ? `- ${category}` : category);
  }

  return parts;
};

// TODO: i18n
export function makePageTitle(tokens: Partial<MetaTokens>) {
  const parts = constructTitleParts(tokens);
  return `${parts.join(" ")} | Thuma`;
}

export function makePageDescription() {
  // TODO: i18n
  return "Elevated design for thoughtful living. Explore mindfully made home essentials and upgrades.";
}
